/* ---- User info display (settings page, display-only) ----
 *
 * Phase 4: 編集機能を撤廃し、現サインイン中のユーザの氏名・メールを
 * 静的なテキストとして表示する。メールアドレスは PII 保護のため
 * ローカル部分の先頭 2 文字を残して残りを `***` でマスクする。
 */

export function renderUserInfoForm(name: string, email: string): HTMLElement {
  const el = document.createElement('div');
  el.className = 'cd';

  const nameDisplay = name ? escapeText(name) : '<span class="ui-empty">未設定</span>';
  const emailDisplay = email
    ? escapeText(maskEmail(email))
    : '<span class="ui-empty">未設定</span>';

  el.innerHTML = `
    <div class="ch">
      <div class="ct" style="margin-bottom:0">ユーザー情報</div>
    </div>
    <div class="ui-row">
      <label class="fml">氏名</label>
      <div class="ui-val">${nameDisplay}</div>
    </div>
    <div class="ui-row" style="margin-bottom:0">
      <label class="fml">メールアドレス</label>
      <div class="ui-val">${emailDisplay}</div>
    </div>
  `;

  return el;
}

/**
 * メールアドレスをマスクする (PII 保護)。
 * ローカル部分の先頭 2 文字を残して残りを `***` に置換、ドメインはそのまま表示。
 *  - `taro@example.com` → `ta***@example.com`
 *  - `ab@example.com`   → `**@example.com` (2 文字以下なら全マスク)
 */
function maskEmail(email: string): string {
  const at = email.indexOf('@');
  if (at < 0) return '***';
  const local = email.slice(0, at);
  const domain = email.slice(at);
  if (local.length <= 2) return '*'.repeat(local.length) + domain;
  return local.slice(0, 2) + '***' + domain;
}

function escapeText(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
